import React, { useState, useEffect } from 'react';
import { Alert, Button } from '@mui/material';
import { isPushSupported, getPushPermission, subscribeToPush } from '../services/pushService';

const PushNotificationBanner: React.FC = () => {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    if (isPushSupported() && getPushPermission() === 'default') {
      setVisible(true);
    }
  }, []);

  if (!visible) return null;

  const handleEnable = async () => {
    await subscribeToPush();
    setVisible(false);
  };

  return (
    <Alert
      severity="info"
      sx={{ mb: 2 }}
      action={
        <Button color="inherit" size="small" onClick={handleEnable}>
          Activer
        </Button>
      }
      onClose={() => setVisible(false)}
    >
      Activez les notifications pour recevoir les messages des parents et des eleves en temps reel.
    </Alert>
  );
};

export default PushNotificationBanner;
